import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { CXDemo } from '@/components/cx-demo/CXDemo';
import { AVAILABLE_COMPANIES, COMPANY_CONFIGS } from '@/constants/cx-companies';

const CustomerExperience: React.FC = () => {
  const [searchParams] = useSearchParams();
  const company = searchParams.get('company');
  const engine = searchParams.get('engine') || '11labs'; // Default to 11labs
  const altAgentParam = searchParams.get('altagent');

  if (!company || !AVAILABLE_COMPANIES.includes(company as any)) {
    return (
      <div className="flex items-center justify-center min-h-screen bg-gray-50">
        <div className="text-center">
          <h1 className="text-2xl font-semibold text-gray-800 mb-2">Invalid Company</h1>
          <p className="text-gray-600">Please provide a valid company parameter.</p>
        </div>
      </div>
    );
  }

  let config = COMPANY_CONFIGS[company as keyof typeof COMPANY_CONFIGS];

  // Override agentId if altagent parameter is provided
  if (altAgentParam !== null && config.altAgentIds) {
    const altAgentIndex = parseInt(altAgentParam, 10);
    if (!isNaN(altAgentIndex) && altAgentIndex >= 0 && altAgentIndex < config.altAgentIds.length) {
      config = {
        ...config,
        agentId: config.altAgentIds[altAgentIndex],
      };
    }
  }

  return <CXDemo config={config} engine={engine as '11labs' | 'realtime'} />;
};

export default CustomerExperience;